export default __webpack_public_path__ + "static/media/54.1b880966.jpg";